module.exports = __webpack_public_path__ + "static/media/content-submit-banner.05f96520.png";